import { useState } from 'react';

// Raw-JSON editor — the fallback for app data with no typed form (admin
// docs/admin.md §6.1 row 2/4). Saves the whole document via PUT (full replace).
// Save is disabled while the text is not a valid JSON object.

export default function JsonEditor({
  initial,
  busy,
  error,
  onSave,
  onCancel,
}: {
  initial: Record<string, unknown>;
  busy: boolean;
  error: string | null;
  onSave: (data: Record<string, unknown>) => void;
  onCancel: () => void;
}) {
  const [text, set_text] = useState(() => JSON.stringify(initial, null, 2));

  let parsed: Record<string, unknown> | null = null;
  let parse_error: string | null = null;
  try {
    const v = JSON.parse(text);
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      parsed = v as Record<string, unknown>;
    } else {
      parse_error = 'Top level must be a JSON object.';
    }
  } catch {
    parse_error = 'Invalid JSON.';
  }

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <p className="muted" style={{ fontSize: 13, margin: 0 }}>
        Raw JSON — full-document replace. No typed form is registered for this app.
      </p>
      <textarea
        value={text}
        onChange={(e) => set_text(e.target.value)}
        spellCheck={false}
        rows={20}
        style={{
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          fontSize: 12,
          padding: 12,
          borderRadius: 4,
          border: `1px solid ${parse_error ? '#b3261e' : 'var(--line)'}`,
          width: '100%',
          boxSizing: 'border-box',
        }}
      />
      {parse_error && <div className="error">{parse_error}</div>}
      {error && <div className="error">Failed to save: {error}</div>}
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          disabled={busy || parsed === null}
          onClick={() => parsed && onSave(parsed)}
        >
          {busy ? 'Saving...' : 'Save (replace)'}
        </button>
        <button type="button" className="secondary" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
      </div>
    </div>
  );
}
